import { render, staticRenderFns } from "./ProjectOccupationChip.vue?vue&type=template&id=86ce0494&"
import script from "./ProjectOccupationChip.vue?vue&type=script&lang=js&"
export * from "./ProjectOccupationChip.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOccupationChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports